import { checkUndefinedNullOrEmpty, checkUndefinedOrNull, isLocalServer } from './Tools';

export function getAllFieldFromArray<T = never>(array: T[], fieldToReturn: keyof T, fallback: T[keyof T][] | undefined): T[keyof T][] | undefined {
    if (checkUndefinedOrNull(array)) {
        if (isLocalServer()) console.warn('array ist leer!', array);
        return fallback;
    }
    if (!Array.isArray(array)) {
        if (isLocalServer()) console.warn('array ist kein Array!', array);
        return fallback;
    }
    if (checkUndefinedOrNull(fieldToReturn)) {
        if (isLocalServer()) console.warn('fieldToReturn ist leer!', array, fieldToReturn);
        return fallback;
    }

    const returnArray: T[keyof T][] = [];
    const filteredArray = array.filter((item) => !checkUndefinedNullOrEmpty(item));
    filteredArray.map((item) => {
        returnArray.push(item[fieldToReturn]);
    });
    return returnArray;
}

export function getElementFromArray<T = never>(array: T[], idToSearch: T[keyof T], fieldToSearch: keyof T, fallback: T | undefined): T | undefined {
    if (checkUndefinedOrNull(array)) {
        if (isLocalServer()) console.warn('array ist leer!', array);
        return fallback;
    }
    if (!Array.isArray(array)) {
        if (isLocalServer()) console.warn('array ist kein Array!', array);
        return fallback;
    }
    if (checkUndefinedOrNull(idToSearch)) {
        if (isLocalServer()) console.warn('idToSearch ist leer!', array, idToSearch);
        return fallback;
    }

    const filteredArray = array.filter((item) => !checkUndefinedNullOrEmpty(item) && item[fieldToSearch] === idToSearch);
    if (checkUndefinedNullOrEmpty(filteredArray)) {
        if (isLocalServer()) console.warn('Kein Eintrag gefunden!', array, idToSearch, filteredArray);
        return fallback;
    }
    if (filteredArray.length > 1) {
        if (isLocalServer()) console.warn('Mehr als 1 Eintrag gefunden!', array, idToSearch, filteredArray);
        return fallback;
    }

    return filteredArray[0];
}

export function getFieldFromArray<T = never>(array: T[], fieldToReturn: keyof T, idToSearch: T[keyof T], fieldToSearch: keyof T, fallback: T[keyof T] | undefined): T[keyof T] | undefined {
    if (checkUndefinedOrNull(array)) {
        if (isLocalServer()) console.warn('array ist leer!', array);
        return fallback;
    }
    if (!Array.isArray(array)) {
        if (isLocalServer()) console.warn('array ist kein Array!', array);
        return fallback;
    }
    if (checkUndefinedOrNull(fieldToReturn)) {
        if (isLocalServer()) console.warn('fieldToReturn ist leer!', array, fieldToReturn);
        return fallback;
    }
    if (checkUndefinedOrNull(idToSearch)) {
        if (isLocalServer()) console.warn('idToSearch ist leer!', array, fieldToReturn, idToSearch);
        return fallback;
    }

    const filteredArray = array.filter((item) => {
        if (!checkUndefinedNullOrEmpty(item)) {
            const field = item[fieldToSearch];
            if (Array.isArray(field)) {
                return field.includes(idToSearch);
            } else {
                return field === idToSearch;
            }
        }
    });
    if (checkUndefinedNullOrEmpty(filteredArray)) {
        if (isLocalServer()) console.warn('Kein Eintrag gefunden!', array, fieldToReturn, idToSearch, filteredArray);
        return fallback;
    }
    if (filteredArray.length > 1) {
        if (isLocalServer()) console.warn('Mehr als 1 Eintrag gefunden!', array, fieldToReturn, idToSearch, filteredArray);
        return fallback;
    }

    return filteredArray[0][fieldToReturn];
}

export function getFieldFromObject<T>(object: T, field: string, fallback?: T[keyof T] | undefined): any | undefined {
    if (checkUndefinedOrNull(object)) {
        if (isLocalServer()) console.warn('Object ist leer!');
        return fallback;
    }
    if (typeof object !== 'object') {
        if (isLocalServer()) console.warn('Object ist kein Objekt!');
        return fallback;
    }
    if (checkUndefinedOrNull(field)) {
        if (isLocalServer()) console.warn('Field ist leer!');
        return fallback;
    }

    const fieldArray = typeof field === 'string' ? (field?.split('.') as (keyof T)[]) : [field];
    let workObj: any = Object.assign({}, object);
    for (let i = 0; i < fieldArray.length; i++) {
        if (!checkUndefinedOrNull(workObj) && !checkUndefinedOrNull(workObj[fieldArray[i]])) {
            workObj = workObj[fieldArray[i]];
        } else {
            workObj = fallback;
            break;
        }
    }
    return workObj;
}

export function formatText(string: string, ...args) {
    if (checkUndefinedOrNull(string)) {
        return;
    }

    const returnArray = [];
    const match = string.match(/{([0-9]+)}/g);

    if (checkUndefinedOrNull(match)) {
        return string;
    }

    let stringOnly = true;
    for (let i = 0; i < match.length; i++) {
        const splitArray = string.split(match[i]);
        returnArray.push(splitArray[0]);
        returnArray.push(args[i]);
        string = string.substring(string.indexOf(match[i]) + match[i].length);
        if (stringOnly && ['function', 'object', 'symbol'].includes(typeof args[i])) {
            stringOnly = false;
        }
    }
    returnArray.push(string);
    return stringOnly ? returnArray.join('') : returnArray;
}

export function stringToSlug(str = ''): string {
    if (checkUndefinedNullOrEmpty(str)) {
        return null;
    }
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.replace(/ß/g, 'ss'); // replace ß
    str = str.replace(/[?!]/g, ''); // remove special characters
    str = str.toLowerCase();

    // remove accents, swap ñ for n, etc
    const from = 'àáãäâèéëêìíïîòóöôùúüûñç';
    const to = 'aaaaaeeeeiiiioooouuuunc';

    for (let i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str
        .replace(/[^A-z0-9/]/g, '-') // remove all except alphanumerics & replace all with '-'
        .replace(/(?!^)\//g, '-') // replace non-leading slashes
        .replace(/-+/g, '-'); // collapse dashes

    return str;
}
